import React, { useContext, useEffect } from "react";
import { LinearProgress, Box } from "@mui/material";
import { UserContext } from "../../../context/CurrentUserProvider";
import GuiasByCompanyForPrint from "../Guias/GuiasByCompanyForPrint";
import Moment from "moment";
import { useOrders } from "../../../hooks/useOrdersProviders/OrdersContext";

const ShippingPrint = (props) => {
  const { userDataContext } = useContext(UserContext);

  // ⚠️ Prueba usando Date reales; si tu hook espera string, ajusta allí.
  const initDateInitial = new Date(); // antes: Moment().format("YYYY-MM-DD")
  const endDateInitial = new Date();

  const orders = useOrders({ initDateInitial, endDateInitial });

  console.group("[ShippingPrint] state snapshot");
  console.log("userDataContext:", userDataContext);
  console.log("orders (raw):", orders);
  console.groupEnd();

  const {
    mergedOrders,
    loadingContext,
    initDate,
    endDate,
    setInitDate,
    setEndDate,
    companiesData,
    listenStart,
    listenStop,
    setShouldSubscribe,
  } = orders || {};

  useEffect(() => {
    if (typeof setShouldSubscribe === "function") {
      console.log("[ShippingPrint] setShouldSubscribe(true)");
      setShouldSubscribe(true);
    } else {
      console.warn(
        "[ShippingPrint] setShouldSubscribe no es función:",
        setShouldSubscribe
      );
    }
  }, [setShouldSubscribe]);

  const userRoll = userDataContext?.roll;
  const userdata = userDataContext?.userData;

  // Más logs antes de renderizar hijo
  console.log("derived:", {
    userRoll,
    hasUserdata: !!userdata,
    loadingContext,
  });
  console.log(
    "mergedOrders:",
    Array.isArray(mergedOrders) ? mergedOrders.length : mergedOrders
  );
  console.log("companiesData:", companiesData);

  const readyForChild =
    userRoll &&
    userdata &&
    mergedOrders !== undefined &&
    companiesData !== undefined &&
    typeof setInitDate === "function" &&
    typeof setEndDate === "function";

  return (
    <>
      {readyForChild ? (
        <Box sx={{ backgroundColor: "#f8f8f8" }}>
          <GuiasByCompanyForPrint
            userdata={userdata}
            firebaseUser={props.firebaseUser}
            usuarioStorage={props.usuarioStorage}
            userDataContext={userDataContext}
            mergedOrders={mergedOrders}
            companiesData={companiesData}
            loadingContext={loadingContext}
            setInitDate={setInitDate}
            setEndDate={setEndDate}
            initDate={initDate}
            endDate={endDate}
          />
        </Box>
      ) : (
        <>
          <LinearProgress />
          {!userRoll && <div>Esperando userRoll…</div>}
          {!userdata && <div>Esperando userdata…</div>}
          {mergedOrders === undefined && <div>Esperando mergedOrders…</div>}
          {companiesData === undefined && <div>Esperando companiesData…</div>}
        </>
      )}
    </>
  );
};

export default ShippingPrint;
